import React from 'react';
import WatchExternalOnDemandSessionButton from '../../WatchExternalOnDemandSessionButton';
import LiveSessionPreviewImage from '../../VirtualSessions/LiveSessionPreviewImage';
import { loginClickOrigin } from '../../../../../constants/Enums';


export default function ExternalOnDemand({
    siteConf,
    eventUrls,
    session,
    me,
    showEmailLogin,
    session: {
        id: sessionId,
        status: sessionStatus,
        enableRecordingSession,
        enableVirtualSession,
        recordingImageUrl,
        recordingSession = {},
    },
    event,
    ticketsSelectionData
}) {

    const { broadcastRecording } = recordingSession;
    const sessionIsUnscheduled = !session.startDate;
    const onDemandButtonText = enableVirtualSession ? 'Watch Recording' : (sessionIsUnscheduled ? 'Watch On Demand' : 'Watch Session');

    return (
        <>
                { enableRecordingSession && broadcastRecording &&
                <WatchExternalOnDemandSessionButton
                    event={event}
                    eventUrls={eventUrls}
                    me={me}
                    session={session}
                    showRegisterAndLoginModal={showEmailLogin}
                    showEmailLogin={showEmailLogin}
                    ticketsSelectionData={ticketsSelectionData}
                    btnText={onDemandButtonText}
                    btnClass={'external-solution-btn'}
                    siteConf={siteConf}
                    analyticData={{
                        clickOrigin: loginClickOrigin.session.onDemandPlayBtn,
                    }}
                />}
                <div className='live-broadcast-container'>
                    <div className="live-broadcast-preview">
                        {recordingImageUrl && (
                            <LiveSessionPreviewImage previewUrl={recordingImageUrl} />
                        )}
                    </div>
                    { enableRecordingSession && !broadcastRecording &&
                    <div className="broadcast-record-footer">
                        <span>{enableVirtualSession ? 'Recording' : 'Content'} will be ready soon</span>
                    </div>
                    }
                </div>

        </>
    );
}
